module.exports = __webpack_public_path__ + "static/media/checkbox-checked.84154b09.svg";